"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _parkingRatesTable = _interopRequireDefault(require("./parking-rates-table"));

var _helpers = require("./helpers");

var _heading = _interopRequireDefault(require("../heading"));

var _paragraph = _interopRequireDefault(require("../paragraph"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var formatParkingTime = function formatParkingTime(timeStr) {
  var _timeStr$split = timeStr.split(':'),
      _timeStr$split2 = (0, _slicedToArray2.default)(_timeStr$split, 2),
      hourStr = _timeStr$split2[0],
      minStr = _timeStr$split2[1];

  var rawHours = parseInt(hourStr, 10);
  var rawMins = parseInt(minStr, 10); // eslint-disable-next-line no-nested-ternary

  return "".concat(rawHours > 12 ? rawHours % 12 : rawHours > 0 ? rawHours : 12).concat(rawMins > 0 && rawMins < 60 ? ":".concat(rawMins) : '').concat(rawHours < 12 ? 'am' : 'pm');
};

var makeFreeTimeLine = function makeFreeTimeLine(freeEntryTime, freeExitTime) {
  var exitText = freeExitTime ? " ensuring you exit before\n  ".concat(formatParkingTime(freeExitTime), ".") : '.';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "We offer ", /*#__PURE__*/_react.default.createElement("strong", null, "free parking"), " with entry after", ' ', formatParkingTime(freeEntryTime), exitText);
};

var ParkingRates = function ParkingRates(_ref) {
  var rateCards = _ref.rateCards,
      freeEntryTime = _ref.freeEntryTime,
      freeExitTime = _ref.freeExitTime,
      cinemaValidation = _ref.cinemaValidation,
      specialConditions = _ref.specialConditions,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? 'Parking rates' : _ref$heading;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, heading && /*#__PURE__*/_react.default.createElement(_heading.default, {
    type: "medium",
    className: _indexModule.default.heading
  }, heading), rateCards.map(function (card) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: card.days.join('-')
    }, /*#__PURE__*/_react.default.createElement(_heading.default, {
      type: "small",
      className: _indexModule.default.heading
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: _indexModule.default.capital
    }, card.days[0]), card.days.length > 1 ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, ' to ', /*#__PURE__*/_react.default.createElement("span", {
      className: _indexModule.default.capital
    }, card.days[card.days.length - 1])) : null), /*#__PURE__*/_react.default.createElement(_parkingRatesTable.default, {
      rates: card.rates
    }), /*#__PURE__*/_react.default.createElement(_paragraph.default, {
      type: "large",
      className: (0, _classnames.default)(_indexModule.default.maxRate, _indexModule.default.extraFees)
    }, "Maximum daily rate ".concat((0, _helpers.formatRate)(card.maximumRate))), /*#__PURE__*/_react.default.createElement(_paragraph.default, {
      type: "large",
      className: (0, _classnames.default)(_indexModule.default.overnightRate, _indexModule.default.extraFees)
    }, "Overnight fee ".concat((0, _helpers.formatRate)(card.overnightRate))));
  }), freeEntryTime && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    type: "large"
  }, makeFreeTimeLine(freeEntryTime, freeExitTime)), specialConditions && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    type: "large"
  }, specialConditions), cinemaValidation && /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.cinemaValidation
  }, cinemaValidation));
};

ParkingRates.propTypes = {
  rateCards: _propTypes.default.arrayOf(_propTypes.default.shape({
    days: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
    rates: _propTypes.default.arrayOf(_propTypes.default.object.isRequired).isRequired,
    maximumRate: _propTypes.default.number.isRequired,
    overnightRate: _propTypes.default.number.isRequired
  })).isRequired,
  freeEntryTime: _propTypes.default.string,
  freeExitTime: _propTypes.default.string,
  cinemaValidation: _propTypes.default.element,
  specialConditions: _propTypes.default.string,
  heading: _propTypes.default.string
};
var _default = ParkingRates;
exports.default = _default;